import { CheckCircle2, Download, GitMerge, SkipForward, XCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { downloadBlob } from "@/lib/intake";

const TILES = [["imported", "Imported", CheckCircle2, "text-success"], ["merged", "Merged", GitMerge, "text-brand"],
  ["failed", "Failed", XCircle, "text-risk"], ["skipped", "Skipped", SkipForward, "text-ink-secondary"]];

export const summaryText = (s) => `${s.imported || 0} imported, ${s.merged || 0} merged, ${s.failed || 0} failed, ${s.skipped || 0} skipped`;

export function ImportSummary({ summary, errorsUrl, errorsName = "import-errors.csv", testId = "import-summary", children }) {
  const download = async () => {
    try { downloadBlob((await api.get(errorsUrl, { responseType: "blob" })).data, errorsName); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="tl-hero space-y-5 p-6" data-testid={testId}>
      <div className="space-y-1">
        <h2 className="font-display text-lg font-semibold">Import complete</h2>
        <p className="text-sm text-ink-secondary" data-testid={`${testId}-text`}>{summaryText(summary)}</p>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {TILES.map(([k, label, Icon, tone]) => (
          <div key={k} className="rounded-[6px] bg-white/80 p-4 ring-1 ring-line" data-testid={`${testId}-${k}`}>
            <p className="flex items-center gap-1.5 text-xs text-ink-muted"><Icon size={13} className={tone} aria-hidden="true" />{label}</p>
            <p className={`font-display text-3xl font-semibold tabular-nums ${tone}`}>{summary[k] || 0}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {errorsUrl && <Button variant="outline" onClick={download} data-testid={`${testId}-error-csv`}><Download size={14} aria-hidden="true" /> Download error CSV</Button>}
        {children}
      </div>
    </section>
  );
}
